import React from 'react';
import SiteSettings from '../../components/AdminNext/SiteSettings';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Site settings — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <SiteSettings />
      </HeadLessLayout>
    )
  };
}

export default action;
